/**
 * DOM Utilities — Safe element creation helpers
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

/**
 * Create a DOM element with attributes and children (no innerHTML)
 * @param {string} tag - HTML tag name
 * @param {Object} [attrs={}] - Element attributes (className, textContent, id, data-*, aria-*, etc.)
 * @param {Array<Node|string>} [children=[]] - Child nodes or text strings
 * @returns {HTMLElement}
 */
export function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [key, val] of Object.entries(attrs)) {
        if (key === 'className') node.className = val;
        else if (key === 'textContent') node.textContent = val;
        else node.setAttribute(key, val);
    }
    for (const child of children) {
        if (typeof child === 'string') node.appendChild(document.createTextNode(child));
        else if (child) node.appendChild(child);
    }
    return node;
}

